import axios from "axios";
import BASE_URL from "../../config";

// Get the auth token from localStorage and return headers
const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// Get bank accounts with filters and pagination
export const getBankAccounts = async (filter = {}) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/BankAccount/get`,
      filter,
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting bank accounts:", error);
    throw error;
  }
};

// Save bank account
export const saveBankAccount = async (bankAccountData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/BankAccount/save`,
      bankAccountData,
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Error saving bank account:", error);
    throw error;
  }
};

